import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

   public static AUTH_TOKEN = "Bearer qDJhbGciOiJIUzI1NiJ9.e30.ZRrHA1JJJW8opsbCGfG_HACGpVUMN_a9IV7pAx_Zdrt56FrtNv";
   public static ROZARPAY_KEY = "rzp_live_t6q0mKroW0SQ7Y"; //rzp_test_oaNZ96X2IrVqx5
}
